export const REGION_OPTIONS = [
  { label: 'IEC', value: 'IEC' },
  { label: 'UL', value: 'UL' }
];
